import React from 'react';
import PropTypes from 'prop-types';

import {Autosuggest} from '../../../fragments/forms';

import API from '../api';


export default class JournalSearchBox extends React.Component {
  static propTypes = {
    reference: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    showError: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      suggestions: [],
      searchKeyword: '',
      readOnly: false,
    };
  }

  componentDidMount() {
    const {reference} = this.props;
    if (reference) {
      const searchKeyword = reference.journal || '';
      this.setState({
        searchKeyword: searchKeyword,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const prevJournal = prevProps.reference ? prevProps.reference.journal : '';
    const currJournal = this.props.reference ? this.props.reference.journal : '';
    if (prevJournal !== currJournal) {
      const searchKeyword = currJournal || '';
      this.setState({
        searchKeyword: searchKeyword,
      });
    }
  }

  async getSuggestions(searchKeyword) {
    if (searchKeyword === '') {
      return [];
    }
    const {viewer: {luJournals}} = await API({journal: searchKeyword});
    let suggestions = luJournals.edges.map(({node}) => node);

    return suggestions;
  }

  getSuggestionValue(selected) {
    const {shortName} = selected;
    return shortName;
  }

  handleSuggestionSelected(e, {suggestionValue}) {
    e && e.preventDefault();

    const {suggestions} = this.state;
    const isNewJournal = this.isNewJournal(suggestionValue, suggestions);

    const {onUpdate, reference} = this.props;
    reference.journal = suggestionValue;
    reference.isNewJournal = isNewJournal;
    onUpdate(reference);

    this.setState({
      searchKeyword: suggestionValue || ''
    });
  }

  renderSuggestion({shortName, fullName}) {
    const fullNameSuffix = fullName.trim() !== shortName.trim() ? ` (${fullName})` : null;
    return (
      <div>
        <strong>{shortName}</strong>{fullNameSuffix}
      </div>
    );
  }

  async handleSuggestionsFetchRequested() {
  }

  async handleInputPropsChange(e, {newValue, method}) {
    if (method === 'click') {
      return;
    }
    const searchKeyword = newValue || '';
    this.setState({
      searchKeyword,
    });

    const suggestions = await this.getSuggestions(searchKeyword);

    const isNewJournal = this.isNewJournal(searchKeyword, suggestions);

    this.setState({
      suggestions
    });

    const {onUpdate, reference} = this.props;
    reference.journal = searchKeyword || '';
    reference.isNewJournal = isNewJournal;
    onUpdate(reference);
  }

  isNewJournal(journalName, suggestions) {
    const lowerCaseSuggestions = suggestions.map(({shortName}) => {
      return shortName.toLowerCase();
    });

    return !(lowerCaseSuggestions.includes(journalName.toLowerCase()));
  }

  get helpMessage() {
    return {
      text: 'Use "Unpublished" for unpublished reference.',
      level: 'info'
    };
  }

  get allMessage() {
    const {helpMessage} = this;
    const {reference, showError} = this.props;

    return [helpMessage].concat(
      reference.messages('journal', showError)
    );
  }

  render() {
    const {allMessage} = this;
    const {
      readOnly,
      searchKeyword,
      suggestions
    } = this.state;

    return (
      <Autosuggest
       name="journal"
       readOnly={readOnly}
       suggestions={suggestions}
       focusInputOnSuggestionClick={false}
       onSuggestionSelected={
        this.handleSuggestionSelected.bind(this)}
       getSuggestionValue={
         this.getSuggestionValue.bind(this)}
       renderSuggestion={
         this.renderSuggestion.bind(this)}
       onSuggestionsFetchRequested={
         this.handleSuggestionsFetchRequested.bind(this)}
       onSuggestionsClearRequested={
         () => {}}
       inputProps={{
         placeholder: 'Type a journal or select one',
         value: searchKeyword,
         onChange: this.handleInputPropsChange.bind(this)
       }}
       messages={allMessage} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/reference-edit/journal-searchbox.js